'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _arrowIconIdentifier = require('../../helpers/arrowIconIdentifier');
var _GalleryArrow = require('./GalleryArrow.scss');var _GalleryArrow2 = _interopRequireDefault(_GalleryArrow);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var GalleryArrow = function GalleryArrow(properties) {var _properties$isShown =
  properties.isShown,isShown = _properties$isShown === undefined ? true : _properties$isShown,className = properties.className,position = properties.position,isMobile = properties.isMobile,globalClassName = properties.globalClassName,navClass = properties.navClass;
  var handleClick = function handleClick(evt) {
    evt.stopPropagation();
    if (properties.handleClick) {
      properties.handleClick();
    }
  };

  return (
    isShown ?
    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_GalleryArrow2.default.arrowWrapper, _GalleryArrow2.default[className], _GalleryArrow2.default[position + 'Arrow'], globalClassName, navClass),
        title: properties.title,
        onClick: handleClick },

      _react2.default.createElement('i', { className: 'icon icon-' + (position === 'left' ? (0, _arrowIconIdentifier.prevIconName)(isMobile) : (0, _arrowIconIdentifier.nextIconName)(isMobile)) })) :

    _react2.default.createElement('div', null));

};exports.default =

GalleryArrow;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryArrow/GalleryArrow.js
// module id = 1209
// module chunks = 0